export default __webpack_public_path__ + "static/media/illustration-algostudy-n-w.25b6732d.webp";